module.exports = __webpack_public_path__ + "img/NF.9c35f8b0.svg";